<template>
  <div id="ClientImagePage" class="grey darken-4 main-content">
    <LeftNav />
    <v-main>
      <ImagesToolbar />

      <v-container fluid class="pt-12">
        <div v-if="searched === true" class="pt-8 white--text">
          Total: {{ resultCount }} - Total selected: {{ selectedCount }}
        </div>

        <v-layout row wrap align-center justify-center class="pa-4">
          <SingleImage
            v-for="(photo, index) in photos"
            v-show="showCheck(photo)"
            :key="index"
            :index="index"
            :photo="photo"
            transition="fade-transition"
          />

          <span v-if="searched === false">
            <v-flex xs12 md8 class="px-4 py2">
              <v-img
                :src="require('../../assets/PIXL8 - Mini Icon.png').default"
                class="mt-6"
                contain
                height="200"
                width="200"
              />
            </v-flex>

            <v-flex v-if="collectionId" xs12 class="dashboard-intro px-4 py2">
              <h6 class="whitetext">Loading collection...</h6>
            </v-flex>

            <v-flex v-else xs12 md8 class="dashboard-intro px-4 py2">
              <h1 class="whitetext">Welcome to PXL8!</h1>
              <p class="whitetext">
                Search your photos using the search filters.
              </p>
            </v-flex>
          </span>
        </v-layout>
      </v-container>
      <v-container>
        <v-layout
          v-show="$store.state.photoSearch.loadingState === true"
          row
          align-center
          justify-center
        >
          <v-progress-circular
            ml-auto
            mr-auto
            align-center
            justify-center
            :size="70"
            :width="7"
            color="secondary"
            transition="fade-transition"
            indeterminate
          ></v-progress-circular>
        </v-layout>
      </v-container>
      <infinite-loading
        v-if="searched === true"
        ref="infiniteLoading"
        @infinite="loadMoreImages"
        :identifier="this.$store.state.photoSearch.searchIdentifier"
      >
        <div slot="spinner" class="whitetext">Loading</div>
        <div slot="no-more" class="whitetext">End of results</div>
        <div slot="no-results" class="whitetext">No results</div>
      </infinite-loading>
    </v-main>
    <MobileFiltersToggle v-if="!this.$route.params.collectionId" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import store from "@/store/";
import {
  PHOTO_SEARCH,
  COLLECTION_RESET_STATE,
  PHOTO_SEARCH_RESET,
} from "@/store/actions.type";

export default {
  name: "ImagesPage",
  props: {
    collectionId: null,
    clientId: null,
  },

  data: () => ({
    searched: false,
  }),
  computed: {
    showSelectedOnly() {
      if (this.showSelected == true) {
        return this.selectedImages;
      }
      return [];
    },
    selectedCount() {
      return this.selectedImagesIds.length;
    },
    resultCount() {
      if (this.imageSearchResult.total) return this.imageSearchResult.total;
      return 0;
    },
    photos() {
      if (this.imageSearchResult.data.length > 0)
        return this.imageSearchResult.data;
      return [];
    },
    ...mapState(["loadingState"]),
    ...mapGetters([
      "selectedImages",
      "selectedImagesIds",
      "imageSearchResult",
      "showSelected",
      "activeExpClient",
    ]),
  },
  watch: {
    "$route.params.collectionId": function (id) {
      if (id === undefined) {
        store.dispatch(PHOTO_SEARCH_RESET);
        this.searched = false;
      }
    },

    photos: {
      handler(val) {
        if (val.length > 0) {
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.stateChanger.reset();
          }
        }
      },
      deep: true,
    },
    imageSearchResult(val) {
      if (val.current_page) this.searched = true;
    },
  },
  mounted() {
    // For unification with collections.
    if (this.$route.params.collectionId) {
      const queries = {};
      queries.per_page = 25;
      queries.page = 1;
      queries.collection_id = this.$route.params.collectionId;
      queries.client_id = this.$route.params.clientId;
      store.dispatch(PHOTO_SEARCH, queries);
    }
  },
  destroyed() {
    store.dispatch(COLLECTION_RESET_STATE);
    store.dispatch(PHOTO_SEARCH_RESET);
  },
  methods: {
    loadMoreImages($state) {
      if (this.imageSearchResult.current_page >= this.imageSearchResult.last_page) {
        console.log('state complete');
        return $state.complete();
      }

      if (this.$store.state.photoSearch.loadingState === true) {
        // ensure not loading already
        console.log('state already loading');
        return;
      }

      console.log(
        this.imageSearchResult.current_page,
        this.imageSearchResult.last_page,
        "LOAD MORE"
      );
      return store
        .dispatch(PHOTO_SEARCH)
        .then((result) => {
          if (result.complete) {
            $state.complete();
          }
          $state.loaded();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showCheck(photo) {
      if (this.showSelected === true) {
        if (photo.selected === true) {
          return true;
        }
        return false;
      }
      return true;
    },
  },
};
</script>
